import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Tabs, Tab } from "react-bootstrap";
import moment from "moment";
import Rating from "react-rating";
import _ from "lodash";
import { DatePicker } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt, faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
import tagTypes from "data/tag-types";
import filterTypes from "data/filter-types";
// import UserStatus from "views/lib/components/user-status";
import UserProfileCards from "views/pages/users/user-profile-cards";
import UserProfileAggregation from "views/pages/users/user-profile-aggregation";
import UserTripHistory from "views/pages/users/user-trip-history";
import ScooterTripHistory from "views/pages/users/scooter-trip-history";
import UserTransactions from "views/pages/users/user-transactions";
import UserStatistics from "views/pages/users/user-statistics";
import UserBikeTripActive from "views/pages/users/user-bike-trip-active";
import UserScooterTripActive from "views/pages/users/user-scooter-trip-active";
import PowerBankRentHistory from "views/pages/users/power-bank-rent-history";
import PowerBankRentActive from "views/pages/users/power-bank-rent-active";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";
import {
  getSingleUser,
  resetSingleUser,
  setUserData,
} from "actions/users/actions";
import {
  getWalletSingle
} from "actions/wallet/actions";
import {
  getNoPagination
} from "actions/tag/actions";
import {
  getList as getSharingList,
  update as updateSharingItem
} from "actions/sharing/actions";

import avatarPlaceholder from "images/avatar.png";

import SearchSelect from "views/lib/components/SearchSelect";
import getFilesUrl from "../../../helpers/getFilesUrl";
import Penalties from "./penalties";
// import ImageWithAuth from "../../lib/components/ImageWithAuth";

class UserProfile extends React.Component {
  format = "DD-MM-YYYY";

  constructor(props) {
    super(props);

    this.state = {
      isMinutesEditMode: false,
      userMinutes: 0,
      isEditMode: false,
      userSingle: {},
      walletSingle: {}
    };

    this.handleImage = this.handleImage.bind(this);
    this.handleEditMode = this.handleEditMode.bind(this);
    this.updateUserRate = this.updateUserRate.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    // this.toggleUserMinutes = this.toggleUserMinutes.bind(this);

    const userId = this.props.match.params.id;

    this.props.getSingleUser(userId);
    this.props.getWalletSingle(userId);
    this.props.getTags([{
      fieldName: "type",
      fieldValue: tagTypes.user,
      searchOperation: filterTypes.EQUALS.value
    }]);

    this.props.getSharingList(0, 1, "id,asc", [{
      fieldName: "id",
      fieldValue: userId,
      searchOperation: filterTypes.EQUALS.value
    }]);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      userSingle: nextProps.userSingle
    });

    if (!_.isEqual(nextProps.walletSingle, this.state.walletSingle)) {
      this.setState({
        walletSingle: nextProps.walletSingle
      });
    }

    if (nextProps.sharingItem.minutes !== this.props.sharingItem.minutes) {
      this.setState({
        userMinutes: nextProps.sharingItem.minutes
      });
    }
  }

  componentWillUnmount() {
    this.props.resetSingleUser();
  }

  handleImage = (imageUrl, title = "Image") => {
    const modalObj = {
      modalSettings: {
        size: "sm"
      },
      header: title,
      children: (
        <img
          src={imageUrl}
          alt={title}
          className="img-fluid"
        />
      ),
      handleClose: () => this.props.closeCustomModal(modalObj)
    };
    this.props.openCustomModal(modalObj);
  };

  handleEditMode = (isEditMode) => {
    this.setState({
      isEditMode
    });
  };

  onChange = (ev) => {
    const {
      name,
      value
    } = ev.target;

    this.setState({
      userSingle: {
        ...this.state.userSingle,
        [name]: value
      }
    });
  };

  onUpdate = () => {
    this.handleEditMode(false);
    this.props.setUserData(this.state.userSingle);
  };

  updateUserRate = (rating) => {
    const userSingle = Object.assign({}, this.state.userSingle);
    userSingle.rating = rating;
    this.props.setUserData(userSingle);
  };

  toggleUserMinutes = () => {
    this.setState(prevState => ({
      isMinutesEditMode: !prevState.isMinutesEditMode
    }));
  };

  resetUserMinutes = () => {
    this.setState({
      isMinutesEditMode: false,
      userMinutes: this.props.sharingItem.minutes
    });
  };

  updateUserMinutes = () => {
    this.props.updateSharingItem(this.state.userSingle.id, {
      ...this.props.sharingItem,
      minutes: this.state.userMinutes
    });

    this.setState({
      isMinutesEditMode: false
    });
  };

  handleSelect = (key) => {
    this.setState({ key });
    this.props.history.replace({
      hash: `${key}`
    });
  };

  render() {
    const {
      tags,
      sharingItem
    } = this.props;
    const {
      isEditMode,
      userSingle,
      walletSingle
    } = this.state;

    const imageSrc = userSingle.avatar
      ? getFilesUrl(userSingle.avatar)
      : avatarPlaceholder;

    const locationHash = this.props.location.hash.substring(1);
    const selectedTab = locationHash === "" ? "profile" : locationHash;

    return (
      <div className="m-2">
        <Tabs
          fill
          id="user-profile-tabs"
          onSelect={this.handleSelect}
          activeKey={selectedTab}
          mountOnEnter={true}
        >
          <Tab eventKey="profile" title="Profile">
            <div className="d-flex justify-content-end mb-2">
              <button
                className="btn btn-outline-danger"
                onClick={() => this.handleEditMode(!isEditMode)}
              >
                <FontAwesomeIcon icon={faPencilAlt}/>
              </button>
            </div>
            <div className="row">
              <div className="col-12 col-md-2">
                {/* <ImageWithAuth node={userSingle.avatar}
                               alt={userSingle.name ? `${userSingle.name} ${userSingle.surname}` : ""}
                               className="img-thumbnail g-pointer"
                               onClick={() => this.handleImage(imageSrc, userSingle.name ? `${userSingle.name} ${userSingle.surname}` : false)}
                /> */}
                <img
                  src={imageSrc}
                  alt={userSingle.name ? `${userSingle.name} ${userSingle.surname}` : ""}
                  className="img-thumbnail g-pointer"
                  onClick={() => this.handleImage(imageSrc, userSingle.name ? `${userSingle.name} ${userSingle.surname}` : false)}
                />
              </div>
              <div className="col-12 col-md-10">
                <table className="table table-hover table-bordered table-striped table-align-middle table-sm">
                  <tbody>
                  <tr>
                    <th>ID</th>
                    <td>{userSingle.id}</td>
                  </tr>
                  <tr>
                    <th>Rating</th>
                    <td>
                      <Rating
                        emptySymbol={<div className="g-pointer user-star"/>}
                        fullSymbol={<div className="g-pointer user-star active"/>}
                        placeholderSymbol={<div className="g-pointer user-star active"/>}
                        placeholderRating={userSingle.rating}
                        onClick={this.updateUserRate}
                        stop={10}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>First Name</th>
                    <td>
                      <input
                        className="form-control"
                        type="text"
                        name="name"
                        readOnly={!isEditMode}
                        value={userSingle.name || ""}
                        onChange={this.onChange}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Last Name</th>
                    <td>
                      <input
                        className="form-control"
                        type="text"
                        name="surname"
                        readOnly={!isEditMode}
                        value={userSingle.surname || ""}
                        onChange={this.onChange}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Birthday</th>
                    <td>
                      <DatePicker
                        value={userSingle.birthday
                          ? moment(`${userSingle.birthday}`)
                          : null}
                        format={this.format}
                        onChange={(date) => {
                          console.log("date-onChange", moment(date)
                            .format(this.format));
                          this.onChange({
                            target: {
                              name: "birthday",
                              value: moment(date)
                                .format(this.format)
                            }
                          });
                        }}
                        className="d-block"
                        placeholder="Not set"
                        disabled={!isEditMode}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Gender</th>
                    <td>
                      <select
                        className="form-control"
                        disabled={!isEditMode}
                        value={userSingle.gender}
                        name="gender"
                        onChange={this.onChange}
                      >
                        <option value="MALE">
                          Male
                        </option>
                        <option value="FEMALE">
                          Female
                        </option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <th>Email</th>
                    <td>
                      <input
                        className="form-control"
                        type="email"
                        name="email"
                        readOnly={!isEditMode}
                        value={userSingle.email ? `${userSingle.email}` : ""}
                        onChange={this.onChange}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Tags</th>
                    <td>
                      <SearchSelect
                        className="search-select"
                        isLoading={false}
                        isDisabled={!isEditMode}
                        onChange={(options) => {
                          this.onChange({
                            target: {
                              name: "tags",
                              value: options
                                ? options.map(item => item.value)
                                : null
                            }
                          });
                        }}
                        options={tags.map(value => ({
                          label: value.name,
                          value: value.name
                        }))}
                        value={userSingle.tags
                          ? userSingle.tags.map(item => ({
                            label: item,
                            value: item
                          })) : null}
                        isMulti={true}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Progress</th>
                    <td>{userSingle.progress}</td>
                  </tr>
                  <tr>
                    <th>Created Date</th>
                    <td>{userSingle.created ? moment(userSingle.created)
                      .format("HH:mm YYYY-MM-DD") : ""}</td>
                  </tr>
                  <tr>
                    <th>Update Date</th>
                    <td>{userSingle.updated ? moment(userSingle.updated)
                      .format("HH:mm YYYY-MM-DD") : ""}</td>
                  </tr>
                  <tr>
                    <th>Notes</th>
                    <td>
                                    <textarea
                                      className="form-control"
                                      name="notes"
                                      readOnly={!isEditMode}
                                      value={userSingle.notes ? userSingle.notes : ""}
                                      onChange={this.onChange}
                                    />
                    </td>
                  </tr>
                  {Array.isArray(userSingle.devices) && userSingle.devices.length ? (
                    <React.Fragment>
                      <tr>
                        <th colSpan={2} className="bg-info">
                          Devices
                        </th>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <table className="table table-borderless table-sm  m-0">
                            <thead>
                            <tr>
                              <th>ID</th>
                              <th>Activated(Date)</th>
                              <th>App Version</th>
                              <th>Device</th>
                            </tr>
                            </thead>
                            <tbody>
                            {userSingle.devices.map((device, deviceIndex) => (
                              <tr key={deviceIndex}>
                                <td>{deviceIndex + 1}</td>
                                <td>{device.activated ? `Yes (${moment(device.activatedOn)
                                  .format("HH:mm DD-MM-YYYY")})` : "No"}</td>
                                <td>{device.appVersion}</td>
                                <td>{device.model ? `${device.model} ${device.osVersion ? `(${device.osVersion})` : ""}` : ""}</td>
                              </tr>
                            ))}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </React.Fragment>
                  ) : null}
                  <tr>
                    <th colSpan={2} className="bg-info">
                      Wallet
                    </th>
                  </tr>
                  <tr>
                    <th>
                      Balance
                    </th>
                    <td>
                      {walletSingle.balance ? walletSingle.balance : 0}
                    </td>
                  </tr>
                  <tr>
                    <th>
                      Debt
                    </th>
                    <td className="p-0">
                      {Array.isArray(walletSingle.debts) ? (
                        <table className="table table-borderless table-sm  m-0">
                          <thead>
                          <tr>
                            <th>ID</th>
                            <th>Type</th>
                            <th>Amount</th>
                            <th>Date</th>
                          </tr>
                          </thead>
                          <tbody>
                          {walletSingle.debts.map(debt => (
                            <tr key={debt.sourceId}>
                              <td>{debt.sourceId}</td>
                              <td>{debt.sourceType}</td>
                              <td>{debt.amount}</td>
                              <td>{moment(debt.generatedAt)
                                .format("HH:mm DD-MM-YYYY")}</td>
                            </tr>
                          ))}
                          </tbody>
                        </table>
                      ) : "No Result"}
                    </td>
                  </tr>
                  <tr>
                    <th>
                      Currency
                    </th>
                    <td>
                      {walletSingle.currency ? walletSingle.currency : "Not Set"}
                    </td>
                  </tr>
                  <tr>
                    <th>
                      Card
                    </th>
                    <td>
                      {walletSingle.card ? (
                        <div>
                          {walletSingle.card.cardholder ? walletSingle.card.cardholder : "Holder Not Set"}
                          <br/>
                          {walletSingle.card.cardMask ? walletSingle.card.cardMask : "Mask Not Set"}
                          <br/>
                          {walletSingle.card.bankType ? walletSingle.card.bankType : "Bank Not Set"}
                          <br/>
                          {walletSingle.card.date ? moment(walletSingle.card.date)
                            .format("YYYY-MM-DD") : ""}
                        </div>
                      ) : "Not Set"}
                    </td>
                  </tr>
                  <tr>
                    <th>Distance</th>
                    <td>{sharingItem.distance || 0}</td>
                  </tr>
                  <tr>
                    <th>Minutes</th>
                    <td className="">
                      <div className="input-group mb-2">
                        <input
                          type="number"
                          className="form-control form-control-sm"
                          value={this.state.userMinutes}
                          onChange={ev => {
                            this.setState({
                              userMinutes: parseInt(ev.target.value, 10)
                            });
                          }}
                          readOnly={!this.state.isMinutesEditMode}
                        />
                        <div className="input-group-append">
                          <button disabled={!this.state.isMinutesEditMode} className="btn btn-sm btn-success"
                                  title="Save" onClick={this.updateUserMinutes}>
                            <FontAwesomeIcon icon={faCheck}/>
                          </button>
                          {this.state.isMinutesEditMode ? (
                            <button className="btn btn-sm btn-danger" title="Cancel" onClick={this.resetUserMinutes}>
                              <FontAwesomeIcon icon={faTimes}/>
                            </button>
                          ) : (
                            <button className="btn btn-sm btn-warning" onClick={this.toggleUserMinutes}>
                              <FontAwesomeIcon icon={faPencilAlt}/>
                            </button>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      Package
                    </th>
                    <td>
                      {sharingItem.package ? (
                        <div>
                          {sharingItem.package.name ? sharingItem.package.name : "No Package"}
                          {sharingItem.package.start && sharingItem.package.end ? (
                            <React.Fragment>
                              <br/>
                              {`${moment(sharingItem.package.start)
                                .format("DD-MM-YYYY")} - ${moment(sharingItem.package.end)
                                .format("DD-MM-YYYY")}`}
                            </React.Fragment>
                          ) : null}
                        </div>
                      ) : "Not Set"}
                    </td>
                  </tr>
                  <tr>
                    <th>
                      Tariff
                    </th>
                    <td>
                      {sharingItem.tariff ? (
                        <div>
                          {sharingItem.tariff.name ? sharingItem.tariff.name : "No Tariff"}
                          {sharingItem.tariff.start && sharingItem.tariff.end ? (
                            <React.Fragment>
                              <br/>
                              {`${moment(sharingItem.tariff.start)
                                .format("DD-MM-YYYY")} - ${moment(sharingItem.tariff.end)
                                .format("DD-MM-YYYY")}`}
                            </React.Fragment>
                          ) : null}
                        </div>
                      ) : "Not Set"}
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div className="text-right">
                  <button
                    disabled={!isEditMode}
                    className={`btn ${isEditMode ? "btn-outline-success" : "btn-default"}`}
                    onClick={this.onUpdate}
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </Tab>
          <Tab eventKey="bike-trips" title="Bike Trips">
            {userSingle.id
              ? <UserTripHistory userId={userSingle.id}/>
              : null}
          </Tab>
          <Tab eventKey="bike-active-trip" title="Bike Active Trips">
            {userSingle.id
              ? <UserBikeTripActive userId={userSingle.id}/>
              : null}
          </Tab>
          <Tab eventKey="scooter-trips" title="Scooter Trips">
            {userSingle.id
              ? <ScooterTripHistory userId={userSingle.id}/>
              : null}
          </Tab>
          <Tab eventKey="scooter-active-trip" title="Scooter Active Trips">
            {userSingle.id
              ? <UserScooterTripActive userId={userSingle.id}/>
              : null}
          </Tab>

          <Tab eventKey="power-bank-rent-history" title="PB Rent History">
            {userSingle.id
              ? <PowerBankRentHistory userId={userSingle.id}/>
              : null}
          </Tab>
          <Tab eventKey="power-bank-rent-active" title="PB Rent Active">
            {userSingle.id
              ? <PowerBankRentActive userId={userSingle.id}/>
              : null}
          </Tab>

          <Tab eventKey="transactions" title="Transactions">
            {userSingle.id
              ? <UserTransactions userId={userSingle.id}/>
              : null}
          </Tab>
          <Tab eventKey="statistics" title="Statistics">
            {userSingle.id
              ? <UserStatistics userId={userSingle.id}/>
              : null}
          </Tab>
          <Tab eventKey="cards" title="Cards">
            {!walletSingle.historicalCards ||
              <UserProfileCards cards={walletSingle.historicalCards}/>}
          </Tab>
          <Tab eventKey="meta" title="Meta">
            {userSingle.id
              ? <UserProfileAggregation userId={userSingle.id}/>
              : null}
          </Tab>
          <Tab eventKey="penalties" title="Penalties">
            <Penalties userId={userSingle.id}/>
          </Tab>
        </Tabs>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userSingle: state.users.userSingle,
  walletSingle: state.wallet.walletSingle,
  tags: state.tag.tagListNoPagination,
  sharingItem: state.sharing.list.content && state.sharing.list.content[0] ? state.sharing.list.content[0] : {},
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getSingleUser: bindActionCreators(getSingleUser, dispatch),
  resetSingleUser: bindActionCreators(resetSingleUser, dispatch),
  setUserData: bindActionCreators(setUserData, dispatch),

  getWalletSingle: bindActionCreators(getWalletSingle, dispatch),

  getTags: bindActionCreators(getNoPagination, dispatch),
  getSharingList: bindActionCreators(getSharingList, dispatch),
  updateSharingItem: bindActionCreators(updateSharingItem, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(UserProfile);



// WEBPACK FOOTER //
// ./src/views/pages/users/user-profile.js